import { Constants } from '../../../../configure/models/constants';
import { sendAlertToServer } from '../../util';
const adjustMapboxControlPosition = () => {
    const controlElement = document.querySelector('.mapboxgl-ctrl-top-right');
    if (controlElement) {
        controlElement.style.top = '130px';
        controlElement.style.right = '5px';
    }
};
const destroyRichMap = () => {
    var _a, _b, _c, _d, _e, _f;
    const existingMap = window.rMap;
    if (!existingMap)
        return;
    try {
        (_a = existingMap.exitNavigation) === null || _a === void 0 ? void 0 : _a.call(existingMap);
    }
    catch (err) {
        console.warn('Failed to exit Rich Map navigation during cleanup', err);
    }
    try {
        (_b = existingMap.removeCurrentPosition) === null || _b === void 0 ? void 0 : _b.call(existingMap);
    }
    catch (err) {
        console.warn('Failed to remove Rich Map current position', err);
    }
    try {
        (_c = existingMap.destroy) === null || _c === void 0 ? void 0 : _c.call(existingMap);
    }
    catch (err) {
        console.warn('Failed to destroy Rich Map instance', err);
    }
    try {
        (_f = (_e = (_d = existingMap.current) === null || _d === void 0 ? void 0 : _d.map) === null || _e === void 0 ? void 0 : _e.remove) === null || _f === void 0 ? void 0 : _f.call(_e);
    }
    catch (err) {
        console.warn('Failed to remove underlying map instance', err);
    }
    window.rMap = null;
};
const initializeRichMap = (mapInit) => {
    try {
        destroyRichMap();
        window.rMap = new RichMap(mapInit);
    }
    catch (err) {
        sendAlertToServer(Constants.ALERTS.RICHMAPS_ERROR, JSON.stringify(err));
    }
};
export { adjustMapboxControlPosition, destroyRichMap, initializeRichMap };
